import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Select from 'react-select';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faMicrophoneAlt } from '@fortawesome/free-solid-svg-icons';

import "../styles/SelectQuiz.css";

const options = [
    { value: 'one', label: 'Quiz One' },
    { value: 'two', label: 'Quiz Two' },
    { value: 'three', label: 'Quiz Three' },
    { value: 'four', label: 'Quiz Four' },
    { value: 'five', label: 'My Quiz' }
  ];

library.add(faMicrophoneAlt);

class SelectQuiz extends Component {
    state = {
        selectedOption: "",
    };

    handleChange = selectedOption => {
        this.setState({ selectedOption });
    };

    render() {
        const { selectedOption } = this.state;
     
        return (      
            <div className="quiz-selection-screen">
                <div className="header">
                    <img className="headerBanner" src={require("../assets/header-footer-colours.jpg")} alt=""/>
                    <div className="headerContent">
                    <div className="logos">
                        <img className="header" src={require("../assets/age-scotland-logo.png")} alt="Age Scotland logo" />
                        <img className="header" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz logo" />
                    </div>
                    <div className="nav">
                        <Link className="" to="/about">Introduction</Link>
                        <Link className="" to="/disclaimer">Disclaimer</Link>
                    </div>
                    <div className="logos"></div>
                    </div>
                </div>
                <div className="content">
                    <h1>Choose your quiz</h1>
                    <Select
                        className="selector"
                        value={selectedOption}
                        onChange={this.handleChange}
                        options={options}
                    />
                    { selectedOption !== "" ? <Link
                        className="button select"  
                        to={{
                        pathname: '/quiz',
                        state: { chosenQuiz: {selectedOption}}
                    }} >
                        Play
                    </Link> : <Link
                        className="button select disabled"
                        style={{ pointerEvents: 'none' }}
                        to={{
                            pathname: '/selectQuiz',
                            state: { chosenQuiz: {selectedOption}}
                        }}
                         >
                        Play
                    </Link> }
                    
                </div>
                <div className="footerBanner">
                    <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="" />
                </div>
            </div>  
        );
      }

}

export default SelectQuiz;
